module.exports = __webpack_public_path__ + "img/14.6166a470.jpg";